<template>
  <div class="application-timelimit__area">
    <div class="application-timelimit__head">
      <h3 class="application-timelimit__title c-with-icon">
        <svg
          class="icon-application-timelimit svg-icon"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 27.5 26.749">
          <path
            class="color1"
            d="M26,4V5.5H1.5V4A1.252,1.252,0,0,1,2.749,2.75h6V4.5a.5.5,
            0,0,0,1,0V2.75h8V4.5a.5.5,0,0,0,1,0V2.75h6A1.252,1.252,0,0,1,
            26,4ZM1.5,7.5H26V24a1.251,1.251,0,0,1-1.25,1.25h-22A1.251,1.251,
            0,0,1,1.5,24ZM17.75,12h4V10h-4Zm0,4h4V14h-4Zm0,4h4V18h-4Zm-6-8h4V10h-4Zm0,
            4h4V14h-4Zm0,4h4V18h-4Zm-6-8h4V10h-4Zm0,4h4V14h-4Zm0,4h4V18h-4Zm19-17.249h-6V4.5a.5.5,
            0,0,1-1,0V2.75h-8V4.5a.5.5,0,0,1-1,0V2.75h-6A1.252,1.252,0,0,0,1.5,4V5.5H26V4A1.252,
            1.252,0,0,0,24.75,2.75ZM1.5,24a1.251,1.251,0,0,0,1.249,1.25h22A1.251,1.251,0,0,0,26,
            24V7.5H1.5Zm26-20V24a2.752,2.752,0,0,1-2.75,2.75h-22A2.752,2.752,0,0,1,0,24V4A2.753,
            2.753,0,0,1,2.749,1.25h6V.5a.5.5,0,1,1,1,0v.75h8V.5a.5.5,0,1,1,1,0v.75h6A2.753,2.753,
            0,0,1,27.5,4ZM26,7.5H1.5V24a1.251,1.251,0,0,0,1.249,1.25h22A1.251,1.251,0,0,0,26,
            24ZM26,4a1.252,1.252,0,0,0-1.25-1.25h-6V4.5a.5.5,0,0,1-1,0V2.75h-8V4.5a.5.5,0,0,1-1,
            0V2.75h-6A1.252,1.252,0,0,0,1.5,4V5.5H26ZM21.749,18h-4v2h4Zm-6,0h-4v2h4Zm-6,
            0h-4v2h4Zm12-4h-4v2h4Zm-6,0h-4v2h4Zm-6,0h-4v2h4Zm12-4h-4v2h4Zm-6,0h-4v2h4Zm-6,
            0h-4v2h4Z"></path>
        </svg>
        配信希望日からリリース申請日を確認する
      </h3>

      <div class="application-timelimit__date-block">
        <div class="form-item-inline form-item-inline--sp-reset">
          <date-select
            v-model="date"
            title="配信希望日"
            :min-date="minDate"
            :max-date="maxDate"
            :is-selected="false"
            class="date-select" />
        </div>
      </div>
      <div class="application-timelimit__btn">
        <div
          :class="[{ 'c-btn--off': !date }]"
          class="c-btn c-btn-timelimit c-btn-calculator"
          :disabled="!date"
          @click.prevent="fetchBackwardSchedules">
          計算する
        </div>
      </div>
    </div>
    <div
      class="application-timelimit__text-block">
      <div class="application-timelimit__text">
        リリース申請日 :
      </div>
      <div
        v-if="allStoreBackwardMinReleaseDate"
        class="application-timelimit__text-date">
        {{
          allStoreBackwardMinReleaseDate | formatDate("YYYY年MM月DD日")
        }}
        <span>（23時59分申請完了まで）</span>
      </div>
      <div
        v-else-if="allStoreBackwardMinReleaseDate===''"
        class="application-timelimit__text-expire">
        リリース申請日を過ぎました
      </div>
      <div
        v-else
        class="application-timelimit__text-default">
        ーーーー年 ーー月 ーー日
      </div>
    </div>
    <div class="application-timelimit__notice_block">
      <div class="application-timelimit__text">
        ※配信ストアのスケジュールにより変動する場合がございます
      </div>
    </div>

    <!-- ストア別配信日の表示は無し -->
    <div
      v-if="minRealeaaseDetailShow"
      class="distribution-date__bottom">
      <div class="distribution-date__bottom-title-block">
        <div class="distribution-date__bottom-text">
          ※ストア別配信時の各ストアの申請期限は下記をご参照下さい。
        </div>
      </div>
      <div class="distribution-date__content">
        <div
          class="distribution-date__block distribution-date__block--subscription">
          <div class="distribution-date__block-title">
            サブスクリプション配信
          </div>
          <div class="distribution-date__block-list-wrap">
            <div class="distribution-date__block-list">
              <div
                v-for="provider in subscriptionProviders"
                :key="provider.key"
                class="distribution-date__block-list-item">
                <div
                  class="distribution-date__block-cell distribution-date__block-cell--th">
                  {{ provider.display_name }}
                </div>
                <div
                  v-if="provider.is_possible"
                  class="distribution-date__block-cell distribution-date__block-cell--td">
                  {{
                    provider.backward_min_release_date
                      | formatDate("YYYY年MM月DD日")
                  }}
                </div>
                <div
                  v-else
                  class="distribution-date__block-cell distribution-date__block-cell--td expired">
                  申請期限日が過ぎました
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          class="distribution-date__block distribution-date__block--download">
          <div class="distribution-date__block-title">
            ダウンロード配信
          </div>
          <div class="distribution-date__block-list-wrap">
            <div class="distribution-date__block-list">
              <div
                v-for="provider in downloadProviders"
                :key="provider.key"
                class="distribution-date__block-list-item">
                <div
                  class="distribution-date__block-cell distribution-date__block-cell--th">
                  {{ provider.display_name }}
                </div>
                <div
                  v-if="provider.is_possible"
                  class="distribution-date__block-cell distribution-date__block-cell--td">
                  {{
                    provider.backward_min_release_date
                      | formatDate("YYYY年MM月DD日")
                  }}
                </div>
                <div
                  v-else
                  class="distribution-date__block-cell distribution-date__block-cell--td expired">
                  申請期限日が過ぎました
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          v-if="databaseProviders.length > 0"
          class="distribution-date__block distribution-date__block--data-base">
          <div class="distribution-date__block-title">その他</div>
          <div class="distribution-date__block-list-wrap">
            <div class="distribution-date__block-list">
              <div
                v-for="provider in databaseProviders"
                :key="provider.key"
                class="distribution-date__block-list-item">
                <div
                  class="distribution-date__block-cell distribution-date__block-cell--th">
                  {{ provider.display_name }}
                </div>
                <div
                  v-if="provider.is_possible"
                  class="distribution-date__block-cell distribution-date__block-cell--td">
                  {{
                    provider.backward_min_release_date
                      | formatDate("YYYY年MM月DD日")
                  }}
                </div>
                <div
                  v-else
                  class="distribution-date__block-cell distribution-date__block-cell--td expired">
                  申請期限日が過ぎました
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="distribution-date__btn--bottom">
          <div
            class="c-btn c-btn--accordion open"
            @click.prevent="onCloseClicked">
            閉じる
            <span></span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import DateSelect from '../../DateSelect'

export default {
  name: 'BackwardMinRealeseSchedules',
  components: {
    DateSelect,
  },
  data() {
    return {
      minDate: null,
      maxDate: null,
      date: '',
      minRealeaaseDetailShow: false,
      providers: [], // 配信先情報マスタ
      allStoreBackwardMinReleaseDate: null,
      leastStoreBackwardMinReleaseDate: null,
      expireBackwardMinReleaseDate: '',
    }
  },
  computed: {
    changeBtnText() {
      return this.minRealeaaseDetailShow ? '閉じる' : '申請期限日を確認する'
    },
    downloadProviders() {
      const site = this.isBtoC ? 'b2c' : 'b2b'
      return this.providers
        .filter(provider => !provider.is_subscription && !provider.is_database_service
                       && (provider.business_direction === site || provider.business_direction === 'all'))
        .sort((provider1, provider2) => (provider1.sort_index < provider2.sort_index ? -1 : 1))
    },
    subscriptionProviders() {
      const site = this.isBtoC ? 'b2c' : 'b2b'
      return this.providers
        .filter(provider => provider.is_subscription && !provider.is_database_service
                       && (provider.business_direction === site || provider.business_direction === 'all'))
        .sort((provider1, provider2) => (provider1.sort_index < provider2.sort_index ? -1 : 1))
    },
    databaseProviders() {
      const site = this.isBtoC ? 'b2c' : 'b2b'
      return this.providers
        .filter(provider => provider.is_database_service
                       && (provider.business_direction === site || provider.business_direction === 'all'))
        .sort((provider1, provider2) => (provider1.sort_index < provider2.sort_index ? -1 : 1))
    },
  },
  watch: {
    date() {
      this.allStoreBackwardMinReleaseDate = null
    },
  },
  mounted() {
    this.fetchItems()
  },
  methods: {
    async fetchItems() {
      const { data } = await window.axios.get('/api/client/providers')
      const providers = window._.orderBy(data, 'min_release_date', 'desc')
      const minDate = moment(
        new Date(window._.last(providers).min_release_date),
      )
      this.minDate = minDate.format('YYYY-MM-DD')
      this.maxDate = minDate.add(120, 'days').format('YYYY-MM-DD')
      // this.date = this.minDate
      // this.fetchBackwardSchedules()
    },
    async fetchBackwardSchedules() {
      const { data } = await window.axios.get(
        '/api/client/providers/backward-schedules',
        {
          params: {
            release_date: this.date,
          },
        },
      )
      this.providers = data
      // "全ストア同日配信の最短日"が存在しない(backward_min_release_dateがnullのプロバイダがある)場合はfalseとなる
      const possibleProvisers = data.filter(
        provider => provider.is_possible,
      )
      const impossibleProvisers = data.filter(
        provider => !provider.is_possible,
      )
      /* eslint-disable max-len */
      // 配信日が一番早いプロバイダー順にソート
      const sortBackwardMinReleaseDate = window._.orderBy(possibleProvisers, 'backward_min_release_date', 'asc')
      // "全ストア同日配信の最短日" が存在する場合はsortBackwardMinReleaseDate先頭データをセット
      if (impossibleProvisers.length === 0) {
        this.allStoreBackwardMinReleaseDate = sortBackwardMinReleaseDate[0].backward_min_release_date
      } else {
        this.allStoreBackwardMinReleaseDate = ''
        const expireBackwardMinReleaseDate = window._.orderBy(impossibleProvisers, 'backward_min_release_date', 'asc')
        this.expireBackwardMinReleaseDate = expireBackwardMinReleaseDate[0].backward_min_release_date
      }

      // "ストア別の最短配信日"を検索(leastStoreBackwardMinReleaseDateを反転させたNULLでない最初のデータ)
      const leastStoreBackwardMinReleaseDate = sortBackwardMinReleaseDate.reverse().find(
        (provider) => provider.backward_min_release_date,
      )
      if (leastStoreBackwardMinReleaseDate) {
        // "ストア別の最短配信日"をセット
        this.leastStoreBackwardMinReleaseDate = leastStoreBackwardMinReleaseDate.backward_min_release_date ?? null
      } else {
        this.leastStoreBackwardMinReleaseDate = null
      }
      /* eslint-enable max-len */
    },
    onCloseClicked() {
      this.minRealeaaseDetailShow = !this.minRealeaaseDetailShow
    },
  },
}
</script>
<style>
</style>
